export default __webpack_public_path__ + "static/media/TMF-logo-default-gold.2c2e20fc.svg";